import { BackendType, FrontendType, ObjectType } from '@starjack/utils';

/** A contest code entered on registration in the portal, with the customer's contact data. */
export type ContestEntry<T extends ObjectType = FrontendType> = {
    /**
     * LocalDateTime as [y, m, d, h, min, s, ns], without zone. It is the auth service's JVM
     * local time; assumption: auth runs in UTC (container default), so it is read as UTC.
     */
    createdAt: T extends BackendType ? number[] : Date;
    code: string;
    customerId: string;
    firstname: string;
    lastname: string;
    email: string;
};

// Not convertDateFromDateArray: it reads 00:00 as a plain date and skips the UTC shift.
const fromUtcDateTimeArray = ([
    year,
    month,
    day,
    hours = 0,
    minutes = 0,
    seconds = 0,
]: number[]) =>
    new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));

export const convertContestEntryFromResponse = (
    entry: ContestEntry<BackendType>
): ContestEntry => ({
    ...entry,
    createdAt: fromUtcDateTimeArray(entry.createdAt),
});
